import { useTranslate } from '@tolgee/react';
import { FC, useEffect } from 'react';
import { Tooltip } from 'bootstrap';
import { OverlayTrigger } from 'react-bootstrap';

interface Props {
  title: String;
  toolTip: boolean;
}

const EditorTitle: FC<Props> = ({ title, toolTip }) => {
  const { t } = useTranslate();

  const syncEditTooltip = `<div class="tooltip" role="tooltip"><div class="d-flex flex-column w-200px bg-white shadow rounded">
              <div class="w-100 mh-200px px-2 py-1 overflow-auto">
                ${t(`lomavisCreator.toolip.${title}`)}
              </div>
            </div></div>'`;
  useEffect(() => {
    const TooltipTrigger = document.querySelector(`.${title}-tooltip-trigger`);

    TooltipTrigger &&
      new Tooltip(TooltipTrigger, {
        title: 'title',
        placement: 'auto',
        trigger: 'hover',
        container: 'body',
        template: syncEditTooltip
      });
  }, []);

  return (
    <div className="d-flex align-items-center mb-0 gap-1">
      <span className="text-gray-900 fw-bold fs-3 mb-0">
        {t(`lomavisCreator.title.${title}`)}
      </span>
      {toolTip && (
        <i
          style={{ cursor: 'pointer', fontSize: '18px' }}
          className={`fa-duotone fa-circle-info ${title}-tooltip-trigger`}
          data-bs-toggle="tooltip"
        ></i>
      )}
    </div>
  );
};
export default EditorTitle;
